(ns client-portal.client.concepts.data
  (:require
    [client-portal.client.products.data :as products.d]
    [shared.core.components.auth0.data :as auth0.d]
    [shared.core.reactive :as re]
    [shared.core.util :as util]))

(def root-path [:concepts])
(def selected-concept-id-path (conj root-path :selected-concept-id))
(def list-path (conj root-path :list))

(defn list-data-path [_]
  (conj list-path :data))

(defn current-concept-id [db]
  (let [auth0-concept-id (auth0.d/auth0-ns-concept-id db)]
    (or (some-> (get-in db selected-concept-id-path) (util/parse-int))
        (when (not= auth0-concept-id "all")
          auth0-concept-id))))

(re/reg-sub :concepts/current-concept-id- current-concept-id)

(re/reg-auth0-loader
  :concepts/load-list-data
  (fn [_ db]
    (list-data-path db))
  {:method :get
   :url "/api/concepts"}
  :transf (fn [resp] (or (some-> resp :body (util/->kebab-case-keywords))
                         ""))
  :error-transf (fn [] []))

(re/reg-auth0-load-sub
  :concepts/list-data-
  (fn [_ db]
    (list-data-path db))
  :concepts/load-list-data)

(re/reg-event-db
  :concepts/select re/middleware
  (fn [db [concept-id]]
    (assoc-in db selected-concept-id-path (util/parse-int concept-id))))

(defn concept-logo-url [concept-id]
  (-> (str "/WNfyNdO6XPyf15otohvs/concept-" concept-id ".png")
      (util/cdn-ui-public-url)))

(defn concept-id+list->concept [cid list]
  (some->> (util/when-not-loading list)
           (filter #(= (str (:id %)) (str cid)))
           (first)))

(defn current-concept [db]
  (let [cid (current-concept-id db)
        list (get-in db (list-data-path db))]
    (concept-id+list->concept cid list)))

(re/reg-sub
  :concepts/selected-
  :<- [:concepts/current-concept-id-]
  :<- [:concepts/list-data-]
  (fn [[cid list]]
    (concept-id+list->concept cid list)))
